import { makeStyles } from '@mui/styles'

const cursorStyle = makeStyles(() => ({
  appCursor: {
    zIndex: 1000,
    width: '30px',
    height: '30px',
    background: 'white',
    borderRadius: '50%',
    position: 'absolute',
    transform: 'translate(-50%,-50%)',
    pointerEvents: 'none',
    transition: 'all 0.5 ease',
    transitionDuration: '200ms',
    transitionTimingFunction: 'ease-out',
    transformOrigin: '100% 100%',
    mixBlendMode: 'difference',
  },
  linkGlow: {
    transform: 'scale(2)',
  },
}))

export default cursorStyle
